import { useAppSelector } from '@/Application/Hooks/Redux';
import { Separator } from '@/modules/perseo-billing/components/separator/separator.component';
import {
  Icon,
  Typography
} from '@/modules/perseo-billing/ui/react/src/components/beta';

import Timer from '../components/timer';

import styles from '../styles.module.scss';

export default function QRPendingContainer() {
  const billing = useAppSelector((state) => state.billing);
  const { isCencoPayTimeOut, cencoPayQR } = billing;

  const transactionCountdown = cencoPayQR?.transactionCountdown ?? 0;

  return (
    <div className="co-flex co-flex-col co-gap-8 co-mb-[44px] co-w-full">
      {!isCencoPayTimeOut && (
        <div className="co-flex co-items-center co-rounded-[8px] co-border-[1px] co-border-[#1245D6] co-p-[8px] co-gap-[6px]">
          <Icon
            icon="InformationIcon"
            height={21}
            width={21}
            className="co-text-pds-neutral-900 !co-fill-[#1245D6] co-flex-shrink-0"
          />
          <Typography>
            Por favor, no cierres esta pantalla hasta terminar el pago
          </Typography>
        </div>
      )}
      <div
        className={`co-flex co-flex-col co-gap-[8px] co-rounded-[8px] co-bg-[#F9F9F9] co-py-[28px] co-items-center ${styles.loadingRotate}`}
      >
        <Icon icon="CencoPayLabel" />
        {isCencoPayTimeOut ? (
          <Icon icon="LoadingCircleCompleted" />
        ) : (
          <Icon icon="LoadingCircle" />
        )}

        <span className={styles.loaderSpinner}></span>

        <Timer transactionCountdown={transactionCountdown} />

        <Typography className="co-w-[250px] co-text-center co-justify-center">
          {isCencoPayTimeOut
            ? 'El código QR expiró.'
            : 'Completa el pago desde la app de CencoPay.'}
        </Typography>
      </div>

      {!isCencoPayTimeOut && (
        <Typography
          noWrap
          align="center"
          className="co-overflow-ellipsis co-overflow-hidden !co-text-[16px] co-mb-4"
        >
          Código:
          <span className="co-font-bold"> {cencoPayQR?.simpleCode}</span>
        </Typography>
      )}

      <Separator className="co-block sm:co-hidden co-bg-[#E6E6E6]" />
    </div>
  );
}
